import React, { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';

import CharsheetLong from '../../components/CharsheetLong'
import RollDice from '../../components/RollDice'
import Spellbook from '../../components/Spellbook.js';
import CharacterSlice from '../../components/CharacterSlice.jsx';

import FlexiGrid from '../../components/common/Flexigrid/Flexigrid.js';

import sample_data from '../../components/Charsheet0/helpers/sample_data.js'
import unflatten from '../../components/Charsheet0/helpers/unflatten.js'
import flatten from '../../components/Charsheet0/helpers/flatten.js';
import getCharacterList from '../../helpers/getCharacterList.js';

import Charsheet01 from '../Charsheet01'

import { UserDataContext } from "../../App.js";

import './Charsheet05.css'

// ----------------------------------------------------------------------------------
//                         Description
//
//     Charsheet05 is a page with one main sheet and 5 optional characters wide
//
//     It is optimized for printing to a sheet of letter paper
//
//     Parents:
//           - pages/Home.js
//
//     Children:
//           - pages/Charsheet01.js
//           - components/CharsheetLong.js  (with Flexigrid for lines)
//           - components/RollDice.js
//
//     Data:
//           - character data for 0..20 characters
//           - char0data is the main character data
// 
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function Charsheet05(props) {

    console.log('CHAR05 props', props)

    // ------------ parameters ---------------

    let startData = { ...sample_data } // <= needs flattening !!

    let flatData = startData.chardata.chars
    for ( var key in flatData ) {
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.stats;
    for ( key in flatData ) {
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.weapons; 
    for ( key in flatData ) {
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.armor;
    for ( key in flatData ) {
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.saves;
    for ( key in flatData ) {
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.spells;
    for ( key in flatData ) {
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.magic;
    for ( key in flatData ) {
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.items;
    for ( key in flatData ) {;
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.potions;
    for ( key in flatData ) {;
        startData[key] = flatData[key];
    }

    flatData = startData.chardata.abilities;
    for ( key in flatData ) {;
        startData[key] = flatData[key];
    }


    // ------ inherited state variables ------
    
    // props.state = charState = [currentChar, setChar]
    const [currentChar, setChar] = props.state;
    const [userData, setUserData] = useContext(UserDataContext);
    
    // -------- local state variables --------
    // const c00 = JSON.parse(localStorage.getItem('char0data')) || null;
    //c00 ? c00["campaign"] = "Greyhawk20" : null;
    // console.log('c00', c00)
    const c0start = (localStorage.getItem('char0data' ) ? flatten(JSON.parse(localStorage.getItem('char0data')),'CS 05 localstorage') : startData )
    // const c0start = startData
    const [ char0data, setChar0Data ] = useState( c0start ); // use char0data from local storage if it is there

    const [ char1data, setChar1Data ] = useState( startData );
    const [ char2data, setChar2Data ] = useState( startData );
    const [ char3data, setChar3Data ] = useState( startData );
    const [ char4data, setChar4Data ] = useState( startData );
    const [ char5data, setChar5Data ] = useState( startData );
    const [ char6data, setChar6Data ] = useState( startData );
    const [ char7data, setChar7Data ] = useState( startData );
    const [ char8data, setChar8Data ] = useState( startData );
    const [ char9data, setChar9Data ] = useState( startData );
    const [ char10data, setChar10Data ] = useState( startData );
    const [ char11data, setChar11Data ] = useState( startData );
    const [ char12data, setChar12Data ] = useState( startData );
    const [ char13data, setChar13Data ] = useState( startData );
    const [ char14data, setChar14Data ] = useState( startData );
    const [ char15data, setChar15Data ] = useState( startData );
    const [ char16data, setChar16Data ] = useState( startData );
    const [ char17data, setChar17Data ] = useState( startData );
    const [ char18data, setChar18Data ] = useState( startData );
    const [ char19data, setChar19Data ] = useState( startData );
    const [ char20data, setChar20Data ] = useState( startData );

    const [ characterList, setCharacterList ] = useState([]);

    // v0.5 spell checks
    let spellCheckArray = [];
    const emptyChecks = ['Empty','Empty','Empty','Empty','Empty','Empty']

    /* 101 */ spellCheckArray.push(useState(emptyChecks))
    /* 102 */ spellCheckArray.push(useState(emptyChecks))
    /* 103 */ spellCheckArray.push(useState(emptyChecks))
    /* 104 */ spellCheckArray.push(useState(emptyChecks))
    /* 105 */ spellCheckArray.push(useState(emptyChecks))
    /* 106 */ spellCheckArray.push(useState(emptyChecks))
    /* 107 */ spellCheckArray.push(useState(emptyChecks))
    /* 108 */ spellCheckArray.push(useState(emptyChecks))
    /* 109 */ spellCheckArray.push(useState(emptyChecks))
    /* 110 */ spellCheckArray.push(useState(emptyChecks))
    /* 111 */ spellCheckArray.push(useState(emptyChecks))
    /* 112 */ spellCheckArray.push(useState(emptyChecks))
    /* 113 */ spellCheckArray.push(useState(emptyChecks))
    /* 114 */ spellCheckArray.push(useState(emptyChecks))
    /* 115 */ spellCheckArray.push(useState(emptyChecks))
    /* 116 */ spellCheckArray.push(useState(emptyChecks))
    /* 117 */ spellCheckArray.push(useState(emptyChecks))
    /* 118 */ spellCheckArray.push(useState(emptyChecks))
    /* 119 */ spellCheckArray.push(useState(emptyChecks))
    /* 120 */ spellCheckArray.push(useState(emptyChecks))
    /* 121 */ spellCheckArray.push(useState(emptyChecks))
    /* 122 */ spellCheckArray.push(useState(emptyChecks))
    /* 123 */ spellCheckArray.push(useState(emptyChecks))
    /* 124 */ spellCheckArray.push(useState(emptyChecks))
    /* 125 */ spellCheckArray.push(useState(emptyChecks))
    /* 126 */ spellCheckArray.push(useState(emptyChecks))
    /* 127 */ spellCheckArray.push(useState(emptyChecks))
    /* 128 */ spellCheckArray.push(useState(emptyChecks))
    /* 129 */ spellCheckArray.push(useState(emptyChecks))
    /* 130 */ spellCheckArray.push(useState(emptyChecks))
    /* 201 */ spellCheckArray.push(useState(emptyChecks))
    /* 202 */ spellCheckArray.push(useState(emptyChecks))
    /* 203 */ spellCheckArray.push(useState(emptyChecks))
    /* 204 */ spellCheckArray.push(useState(emptyChecks))
    /* 205 */ spellCheckArray.push(useState(emptyChecks))
    /* 206 */ spellCheckArray.push(useState(emptyChecks))
    /* 207 */ spellCheckArray.push(useState(emptyChecks))
    /* 208 */ spellCheckArray.push(useState(emptyChecks))
    /* 209 */ spellCheckArray.push(useState(emptyChecks))
    /* 210 */ spellCheckArray.push(useState(emptyChecks))
    /* 211 */ spellCheckArray.push(useState(emptyChecks))
    /* 212 */ spellCheckArray.push(useState(emptyChecks))
    /* 213 */ spellCheckArray.push(useState(emptyChecks))
    /* 214 */ spellCheckArray.push(useState(emptyChecks))
    /* 215 */ spellCheckArray.push(useState(emptyChecks))
    /* 216 */ spellCheckArray.push(useState(emptyChecks))
    /* 217 */ spellCheckArray.push(useState(emptyChecks))
    /* 218 */ spellCheckArray.push(useState(emptyChecks))
    /* 219 */ spellCheckArray.push(useState(emptyChecks))
    /* 220 */ spellCheckArray.push(useState(emptyChecks))
    /* 221 */ spellCheckArray.push(useState(emptyChecks))
    /* 222 */ spellCheckArray.push(useState(emptyChecks))
    /* 223 */ spellCheckArray.push(useState(emptyChecks))
    /* 224 */ spellCheckArray.push(useState(emptyChecks))
    /* 225 */ spellCheckArray.push(useState(emptyChecks))
    /* 226 */ spellCheckArray.push(useState(emptyChecks))
    /* 227 */ spellCheckArray.push(useState(emptyChecks))
    /* 228 */ spellCheckArray.push(useState(emptyChecks))
    /* 229 */ spellCheckArray.push(useState(emptyChecks))
    /* 230 */ spellCheckArray.push(useState(emptyChecks))
    /* 301 */ spellCheckArray.push(useState(emptyChecks))
    /* 302 */ spellCheckArray.push(useState(emptyChecks))
    /* 303 */ spellCheckArray.push(useState(emptyChecks))
    /* 304 */ spellCheckArray.push(useState(emptyChecks))
    /* 305 */ spellCheckArray.push(useState(emptyChecks))
    /* 306 */ spellCheckArray.push(useState(emptyChecks))
    /* 307 */ spellCheckArray.push(useState(emptyChecks))
    /* 308 */ spellCheckArray.push(useState(emptyChecks))
    /* 309 */ spellCheckArray.push(useState(emptyChecks))
    /* 310 */ spellCheckArray.push(useState(emptyChecks))
    /* 311 */ spellCheckArray.push(useState(emptyChecks))
    /* 312 */ spellCheckArray.push(useState(emptyChecks))
    /* 313 */ spellCheckArray.push(useState(emptyChecks))
    /* 314 */ spellCheckArray.push(useState(emptyChecks))
    /* 315 */ spellCheckArray.push(useState(emptyChecks))
    /* 316 */ spellCheckArray.push(useState(emptyChecks))
    /* 317 */ spellCheckArray.push(useState(emptyChecks))
    /* 318 */ spellCheckArray.push(useState(emptyChecks))
    /* 319 */ spellCheckArray.push(useState(emptyChecks))
    /* 320 */ spellCheckArray.push(useState(emptyChecks))
    /* 321 */ spellCheckArray.push(useState(emptyChecks))
    /* 322 */ spellCheckArray.push(useState(emptyChecks))
    /* 323 */ spellCheckArray.push(useState(emptyChecks))
    /* 324 */ spellCheckArray.push(useState(emptyChecks))
    /* 325 */ spellCheckArray.push(useState(emptyChecks))
    /* 326 */ spellCheckArray.push(useState(emptyChecks))
    /* 327 */ spellCheckArray.push(useState(emptyChecks))
    /* 328 */ spellCheckArray.push(useState(emptyChecks))
    /* 329 */ spellCheckArray.push(useState(emptyChecks))
    /* 330 */ spellCheckArray.push(useState(emptyChecks))
    /* 401 */ spellCheckArray.push(useState(emptyChecks))
    /* 402 */ spellCheckArray.push(useState(emptyChecks))
    /* 403 */ spellCheckArray.push(useState(emptyChecks))
    /* 404 */ spellCheckArray.push(useState(emptyChecks))
    /* 405 */ spellCheckArray.push(useState(emptyChecks))
    /* 406 */ spellCheckArray.push(useState(emptyChecks))
    /* 407 */ spellCheckArray.push(useState(emptyChecks))
    /* 408 */ spellCheckArray.push(useState(emptyChecks))
    /* 409 */ spellCheckArray.push(useState(emptyChecks))
    /* 410 */ spellCheckArray.push(useState(emptyChecks))
    /* 411 */ spellCheckArray.push(useState(emptyChecks))
    /* 412 */ spellCheckArray.push(useState(emptyChecks))
    /* 413 */ spellCheckArray.push(useState(emptyChecks))
    /* 414 */ spellCheckArray.push(useState(emptyChecks))
    /* 415 */ spellCheckArray.push(useState(emptyChecks))
    /* 416 */ spellCheckArray.push(useState(emptyChecks))
    /* 417 */ spellCheckArray.push(useState(emptyChecks))
    /* 418 */ spellCheckArray.push(useState(emptyChecks))
    /* 419 */ spellCheckArray.push(useState(emptyChecks))
    /* 420 */ spellCheckArray.push(useState(emptyChecks))
    /* 421 */ spellCheckArray.push(useState(emptyChecks))
    /* 422 */ spellCheckArray.push(useState(emptyChecks))
    /* 423 */ spellCheckArray.push(useState(emptyChecks))
    /* 424 */ spellCheckArray.push(useState(emptyChecks))
    /* 425 */ spellCheckArray.push(useState(emptyChecks))
    /* 426 */ spellCheckArray.push(useState(emptyChecks))
    /* 427 */ spellCheckArray.push(useState(emptyChecks))
    /* 428 */ spellCheckArray.push(useState(emptyChecks))
    /* 429 */ spellCheckArray.push(useState(emptyChecks))
    /* 430 */ spellCheckArray.push(useState(emptyChecks))
    /* 501 */ spellCheckArray.push(useState(emptyChecks))
    /* 502 */ spellCheckArray.push(useState(emptyChecks))
    /* 503 */ spellCheckArray.push(useState(emptyChecks))
    /* 504 */ spellCheckArray.push(useState(emptyChecks))
    /* 505 */ spellCheckArray.push(useState(emptyChecks))
    /* 506 */ spellCheckArray.push(useState(emptyChecks))
    /* 507 */ spellCheckArray.push(useState(emptyChecks))
    /* 508 */ spellCheckArray.push(useState(emptyChecks))
    /* 509 */ spellCheckArray.push(useState(emptyChecks))
    /* 510 */ spellCheckArray.push(useState(emptyChecks))
    /* 511 */ spellCheckArray.push(useState(emptyChecks))
    /* 512 */ spellCheckArray.push(useState(emptyChecks))
    /* 513 */ spellCheckArray.push(useState(emptyChecks))
    /* 514 */ spellCheckArray.push(useState(emptyChecks))
    /* 515 */ spellCheckArray.push(useState(emptyChecks))
    /* 516 */ spellCheckArray.push(useState(emptyChecks))
    /* 517 */ spellCheckArray.push(useState(emptyChecks))
    /* 518 */ spellCheckArray.push(useState(emptyChecks))
    /* 519 */ spellCheckArray.push(useState(emptyChecks))
    /* 520 */ spellCheckArray.push(useState(emptyChecks))
    /* 521 */ spellCheckArray.push(useState(emptyChecks))
    /* 522 */ spellCheckArray.push(useState(emptyChecks))
    /* 523 */ spellCheckArray.push(useState(emptyChecks))
    /* 524 */ spellCheckArray.push(useState(emptyChecks))
    /* 525 */ spellCheckArray.push(useState(emptyChecks))
    /* 526 */ spellCheckArray.push(useState(emptyChecks))
    /* 527 */ spellCheckArray.push(useState(emptyChecks))
    /* 528 */ spellCheckArray.push(useState(emptyChecks))
    /* 529 */ spellCheckArray.push(useState(emptyChecks))
    /* 530 */ spellCheckArray.push(useState(emptyChecks))
    /* 601 */ spellCheckArray.push(useState(emptyChecks))
    /* 602 */ spellCheckArray.push(useState(emptyChecks))
    /* 603 */ spellCheckArray.push(useState(emptyChecks))
    /* 604 */ spellCheckArray.push(useState(emptyChecks))
    /* 605 */ spellCheckArray.push(useState(emptyChecks))
    /* 606 */ spellCheckArray.push(useState(emptyChecks))
    /* 607 */ spellCheckArray.push(useState(emptyChecks))
    /* 608 */ spellCheckArray.push(useState(emptyChecks))
    /* 609 */ spellCheckArray.push(useState(emptyChecks))
    /* 610 */ spellCheckArray.push(useState(emptyChecks))
    /* 611 */ spellCheckArray.push(useState(emptyChecks))
    /* 612 */ spellCheckArray.push(useState(emptyChecks))
    /* 613 */ spellCheckArray.push(useState(emptyChecks))
    /* 614 */ spellCheckArray.push(useState(emptyChecks))
    /* 615 */ spellCheckArray.push(useState(emptyChecks))
    /* 616 */ spellCheckArray.push(useState(emptyChecks))
    /* 617 */ spellCheckArray.push(useState(emptyChecks))
    /* 618 */ spellCheckArray.push(useState(emptyChecks))
    /* 619 */ spellCheckArray.push(useState(emptyChecks))
    /* 620 */ spellCheckArray.push(useState(emptyChecks))
    /* 621 */ spellCheckArray.push(useState(emptyChecks))
    /* 622 */ spellCheckArray.push(useState(emptyChecks))
    /* 623 */ spellCheckArray.push(useState(emptyChecks))
    /* 624 */ spellCheckArray.push(useState(emptyChecks))
    /* 625 */ spellCheckArray.push(useState(emptyChecks))
    /* 626 */ spellCheckArray.push(useState(emptyChecks))
    /* 627 */ spellCheckArray.push(useState(emptyChecks))
    /* 628 */ spellCheckArray.push(useState(emptyChecks))
    /* 629 */ spellCheckArray.push(useState(emptyChecks))
    /* 630 */ spellCheckArray.push(useState(emptyChecks))
    /* 701 */ spellCheckArray.push(useState(emptyChecks))
    /* 702 */ spellCheckArray.push(useState(emptyChecks))
    /* 703 */ spellCheckArray.push(useState(emptyChecks))
    /* 704 */ spellCheckArray.push(useState(emptyChecks))
    /* 705 */ spellCheckArray.push(useState(emptyChecks))
    /* 706 */ spellCheckArray.push(useState(emptyChecks))
    /* 707 */ spellCheckArray.push(useState(emptyChecks))
    /* 708 */ spellCheckArray.push(useState(emptyChecks))
    /* 709 */ spellCheckArray.push(useState(emptyChecks))
    /* 710 */ spellCheckArray.push(useState(emptyChecks))
    /* 711 */ spellCheckArray.push(useState(emptyChecks))
    /* 712 */ spellCheckArray.push(useState(emptyChecks))
    /* 713 */ spellCheckArray.push(useState(emptyChecks))
    /* 714 */ spellCheckArray.push(useState(emptyChecks))
    /* 715 */ spellCheckArray.push(useState(emptyChecks))
    /* 716 */ spellCheckArray.push(useState(emptyChecks))
    /* 717 */ spellCheckArray.push(useState(emptyChecks))
    /* 718 */ spellCheckArray.push(useState(emptyChecks))
    /* 719 */ spellCheckArray.push(useState(emptyChecks))
    /* 720 */ spellCheckArray.push(useState(emptyChecks))
    /* 721 */ spellCheckArray.push(useState(emptyChecks))
    /* 722 */ spellCheckArray.push(useState(emptyChecks))
    /* 723 */ spellCheckArray.push(useState(emptyChecks))
    /* 724 */ spellCheckArray.push(useState(emptyChecks))
    /* 725 */ spellCheckArray.push(useState(emptyChecks))
    /* 726 */ spellCheckArray.push(useState(emptyChecks))
    /* 727 */ spellCheckArray.push(useState(emptyChecks))
    /* 728 */ spellCheckArray.push(useState(emptyChecks))
    /* 729 */ spellCheckArray.push(useState(emptyChecks))
    /* 730 */ spellCheckArray.push(useState(emptyChecks))
    /* 801 */ spellCheckArray.push(useState(emptyChecks))
    /* 802 */ spellCheckArray.push(useState(emptyChecks))
    /* 803 */ spellCheckArray.push(useState(emptyChecks))
    /* 804 */ spellCheckArray.push(useState(emptyChecks))
    /* 805 */ spellCheckArray.push(useState(emptyChecks))
    /* 806 */ spellCheckArray.push(useState(emptyChecks))
    /* 807 */ spellCheckArray.push(useState(emptyChecks))
    /* 808 */ spellCheckArray.push(useState(emptyChecks))
    /* 809 */ spellCheckArray.push(useState(emptyChecks))
    /* 810 */ spellCheckArray.push(useState(emptyChecks))
    /* 811 */ spellCheckArray.push(useState(emptyChecks))
    /* 812 */ spellCheckArray.push(useState(emptyChecks))
    /* 813 */ spellCheckArray.push(useState(emptyChecks))
    /* 814 */ spellCheckArray.push(useState(emptyChecks))
    /* 815 */ spellCheckArray.push(useState(emptyChecks))
    /* 816 */ spellCheckArray.push(useState(emptyChecks))
    /* 817 */ spellCheckArray.push(useState(emptyChecks))
    /* 818 */ spellCheckArray.push(useState(emptyChecks))
    /* 819 */ spellCheckArray.push(useState(emptyChecks))
    /* 820 */ spellCheckArray.push(useState(emptyChecks))
    /* 821 */ spellCheckArray.push(useState(emptyChecks))
    /* 822 */ spellCheckArray.push(useState(emptyChecks))
    /* 823 */ spellCheckArray.push(useState(emptyChecks))
    /* 824 */ spellCheckArray.push(useState(emptyChecks))
    /* 825 */ spellCheckArray.push(useState(emptyChecks))
    /* 826 */ spellCheckArray.push(useState(emptyChecks))
    /* 827 */ spellCheckArray.push(useState(emptyChecks))
    /* 828 */ spellCheckArray.push(useState(emptyChecks))
    /* 829 */ spellCheckArray.push(useState(emptyChecks))
    /* 830 */ spellCheckArray.push(useState(emptyChecks))
    /* 901 */ spellCheckArray.push(useState(emptyChecks))
    /* 902 */ spellCheckArray.push(useState(emptyChecks))
    /* 903 */ spellCheckArray.push(useState(emptyChecks))
    /* 904 */ spellCheckArray.push(useState(emptyChecks))
    /* 905 */ spellCheckArray.push(useState(emptyChecks))
    /* 906 */ spellCheckArray.push(useState(emptyChecks))
    /* 907 */ spellCheckArray.push(useState(emptyChecks))
    /* 908 */ spellCheckArray.push(useState(emptyChecks))
    /* 909 */ spellCheckArray.push(useState(emptyChecks))
    /* 910 */ spellCheckArray.push(useState(emptyChecks))
    /* 911 */ spellCheckArray.push(useState(emptyChecks))
    /* 912 */ spellCheckArray.push(useState(emptyChecks))
    /* 913 */ spellCheckArray.push(useState(emptyChecks))
    /* 914 */ spellCheckArray.push(useState(emptyChecks))
    /* 915 */ spellCheckArray.push(useState(emptyChecks))
    /* 916 */ spellCheckArray.push(useState(emptyChecks))
    /* 917 */ spellCheckArray.push(useState(emptyChecks))
    /* 918 */ spellCheckArray.push(useState(emptyChecks))
    /* 919 */ spellCheckArray.push(useState(emptyChecks))
    /* 920 */ spellCheckArray.push(useState(emptyChecks))
    /* 921 */ spellCheckArray.push(useState(emptyChecks))
    /* 922 */ spellCheckArray.push(useState(emptyChecks))
    /* 923 */ spellCheckArray.push(useState(emptyChecks))
    /* 924 */ spellCheckArray.push(useState(emptyChecks))
    /* 925 */ spellCheckArray.push(useState(emptyChecks))
    /* 926 */ spellCheckArray.push(useState(emptyChecks))
    /* 927 */ spellCheckArray.push(useState(emptyChecks))
    /* 928 */ spellCheckArray.push(useState(emptyChecks))
    /* 929 */ spellCheckArray.push(useState(emptyChecks))
    /* 930 */ spellCheckArray.push(useState(emptyChecks))



    /* v0.4 spell checks
    let spellChecks11 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks11);
    let spellChecks12 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks12);
    let spellChecks13 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks13);
    let spellChecks14 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks14);
    let spellChecks15 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks15);
    let spellChecks16 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks16);
    let spellChecks17 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks17);
    let spellChecks18 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks18);
    let spellChecks19 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks19);
    let spellChecks20 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks20);
    let spellChecks21 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks21);
    let spellChecks22 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks22);
    let spellChecks23 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks23);
    let spellChecks24 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks24);
    let spellChecks25 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks25);
    let spellChecks26 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks26);
    let spellChecks27 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks27);
    let spellChecks28 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks28);
    let spellChecks29 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks29);
    let spellChecks30 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks30);
    let spellChecks31 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks31);
    let spellChecks32 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks32);
    let spellChecks33 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks33);
    let spellChecks34 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks34);
    let spellChecks35 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks35);
    let spellChecks36 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks36);
    let spellChecks37 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks37);
    let spellChecks38 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks38);
    let spellChecks39 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks39);
    let spellChecks40 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks40);
    let spellChecks41 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks41);
    let spellChecks42 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks42);
    let spellChecks43 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks43);
    let spellChecks44 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks44);
    let spellChecks45 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks45);
    let spellChecks46 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks46);
    let spellChecks47 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks47);
    let spellChecks48 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks48);
    let spellChecks49 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks49);
    let spellChecks50 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks50);
    let spellChecks51 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks51);
    let spellChecks52 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks52);
    let spellChecks53 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks53);
    let spellChecks54 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks54);
    let spellChecks55 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks55);
    let spellChecks56 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks56);
    let spellChecks57 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks57);
    let spellChecks58 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks58);
    let spellChecks59 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks59);
    let spellChecks60 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks60);
    let spellChecks61 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks61);
    let spellChecks62 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks62);
    let spellChecks63 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks63);
    let spellChecks64 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks64);
    let spellChecks65 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks65);
    let spellChecks66 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks66);
    let spellChecks67 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks67);
    let spellChecks68 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks68);
    let spellChecks69 = useState(['69   ','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks69);
    let spellChecks70 = useState(['Empty','Empty','Empty','Empty','Empty','Empty']); spellCheckArray.push(spellChecks70);
*/
    // ------------- useEffect ---------------

    useEffect( () => {
        // const { chardata, ...dataToStore } = char0data;
        let dataToStore = { };
        dataToStore.name = char0data.name;
        dataToStore.campaign =Cookies.get('currentCampaign');
        dataToStore.chardata = unflatten(char0data);
        localStorage.setItem('char0data', JSON.stringify(dataToStore));
        
    },[char0data]); //useEffect

    useEffect( () => {
        console.log('char1data changed ', char1data)
        }
    ,[char1data]);

    useEffect( () => {
        async function fetchCharacterList() {
            const characterListNew = await getCharacterList(userData); // Wait for the promise to resolve
            setCharacterList(characterListNew); // Log the resolved value
        }

        fetchCharacterList();
    },[userData]); //useEffect

    // ---------- return html (jsx) ----------

    const rowLabels = () => {

        const rowNames = ['Name','Class','Race','Align','STR','INT','WIS','DEX','CON','CHA','HP','Weap','Armor','Saves','Follow','Spells','Magic','Items', 'Pots','Racial', 'Other', 'Gold','XP'];
        const rowEnds =  [        4,      6,     8,      10,   12,   14,   16,   18,   20,   22,   26,   36,     46,     52,      56,      74,     79,      89,    95,       101,      107,  109,  113];

        let cells = {}
        let data = {}

        for ( var row in rowNames ) {
            let name = rowNames[row];
            let rowStart = 1;
            if (row>0) { rowStart = rowEnds[row-1]};
            let rowEnd = rowEnds[row]
            cells['txt'+name] = [1,2,rowStart,rowEnd]
            data['txt'+name] = name
        }
        return {cells: cells, data: data };
    }


    // ---------  Return JSX ---------------------------------------------------------------------

    return (
        <>
        <div id = 'five-wide' style={{marginTop: '5px', width: 'fit-content', position: 'relative' }}>

        <Charsheet01 state={ props.state } data={ char0data } setdata={ setChar0Data } 
            charID='char0' spellCheckArray={spellCheckArray} activeViewArray={props.activeViewArray} />

        <RollDice class="full" />

        <div id = 'char-form-05' className='no-print' style={{width: 'fit-content', position: 'relative', flexDirection: 'row', display: 'none' }}>
            <FlexiGrid
                rowSize = '9px'
                colSize = '40px'
                id='labels'
                classRoot= 'lab'
                cells = { rowLabels().cells }
                data = { rowLabels().data }
                boxes={{ boxName: [1,2,1,4], boxA: [ 1,2,4,10 ], boxB:[1,2,10,22], boxC: [1,2,22,26], boxD: [1,2,26,36], boxE: [1,2,36,46],
                         boxF: [1,2,46,52], boxG:[1,2,52,56], boxSpells: [1,2,56,74],
                         boxMagic: [1,2,74,79], boxItems:[1,2,79,89], boxPots: [1,2,89,95], 
                         boxRacial: [1,2,95,101], boxOther: [1,2,101,107], boxGold: [1,2,107,109], boxXP: [1,2,109,113]
                        }}

                       
            />
 
            <CharsheetLong state={props.state} data={char1data} setdata={setChar1Data} charID='char1' characterlist={characterList} />
            <CharsheetLong state={props.state} data={char2data} setdata={setChar2Data} charID='char2' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char3data} setdata={setChar3Data} charID='char3' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char4data} setdata={setChar4Data} charID='char4' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char5data} setdata={setChar5Data} charID='char5' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char6data} setdata={setChar6Data} charID='char6' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char7data} setdata={setChar7Data} charID='char7' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char8data} setdata={setChar8Data} charID='char8' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char9data} setdata={setChar9Data} charID='char9' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char10data} setdata={setChar10Data} charID='char10' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char11data} setdata={setChar11Data} charID='char11' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char12data} setdata={setChar12Data} charID='char12' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char13data} setdata={setChar13Data} charID='char13' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char14data} setdata={setChar14Data} charID='char14' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char15data} setdata={setChar15Data} charID='char15' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char16data} setdata={setChar16Data} charID='char16' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char17data} setdata={setChar17Data} charID='char17' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char18data} setdata={setChar18Data} charID='char18' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char19data} setdata={setChar19Data} charID='char19' characterlist={characterList}/>
            <CharsheetLong state={props.state} data={char20data} setdata={setChar20Data} charID='char20' characterlist={characterList}/>

            
        </div>
        </div>
{/*        
        <CharacterSlice charDataArray={[ char1data, setChar1Data ]} globalState={props.state} />
        <CharacterSlice charDataArray={[ char2data, setChar2Data ]} globalState={props.state} />
        <CharacterSlice charDataArray={[ char3data, setChar3Data ]} globalState={props.state} />
        <CharacterSlice charDataArray={[ char4data, setChar4Data ]} globalState={props.state} />
        <CharacterSlice charDataArray={[ char5data, setChar5Data ]} globalState={props.state} />
        <CharacterSlice charDataArray={[ char6data, setChar6Data ]} globalState={props.state} />
        <CharacterSlice charDataArray={[ char7data, setChar7Data ]} globalState={props.state} />
        <CharacterSlice charDataArray={[ char8data, setChar8Data ]} globalState={props.state} />
 */}       
        <Spellbook globalState={props.state} chardata={char0data} />
        </>
    )

    };  // end of function

    export default Charsheet05